import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';

const MetricCard = ({ title, metrics, loading, color = 'primary', icon }) => {
    if (loading) {
        return (
            <Card className="card-animate border-0 shadow-sm h-100">
                <CardBody className="d-flex align-items-center justify-content-center" style={{ minHeight: 120 }}>
                    <Spinner size="sm" color={color} />
                </CardBody>
            </Card>
        );
    }

    if (!metrics) {
        return (
            <Card className="card-animate border-0 shadow-sm h-100">
                <CardBody className="text-center text-muted" style={{ minHeight: 120 }}>
                    <small>No data</small>
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="card-animate border-0 shadow-sm h-100">
            <CardBody className="p-3">
                <div className="d-flex align-items-center mb-2">
                    {icon && (
                        <div className={`avatar-xs rounded bg-soft-${color} text-${color} d-flex align-items-center justify-content-center me-2`}>
                            <i className={icon} style={{ fontSize: 14 }}></i>
                        </div>
                    )}
                    <h6 className="mb-0 text-uppercase fw-semibold text-muted" style={{ fontSize: 11, letterSpacing: '0.5px' }}>
                        {title}
                    </h6>
                </div>
                <div className="d-flex flex-wrap gap-3 mt-2">
                    {metrics.map((m, idx) => (
                        <div key={idx} className="text-center">
                            <h4 className={`mb-0 text-${color} fw-bold`}>
                                {m.value ?? '—'}
                            </h4>
                            <p className="text-muted mb-0" style={{ fontSize: 11 }}>{m.label}</p>
                        </div>
                    ))}
                </div>
            </CardBody>
        </Card>
    );
};

export default MetricCard;
